import { getLocalePack, type LaunchLocale } from "../../locales/src/locales";
import { screens } from "./router";
const titles: Record<LaunchLocale, string[]> = {
  en: screens.map((s) => s.name),
  es: [
    "Descubrir",
    "Resultados de búsqueda",
    "Artículo y procedencia",
    "Tienda",
    "Favoritos y colecciones",
    "Lista y reserva de regalos",
    "Carrito de varias tiendas",
    "Pago y confirmación",
    "Recibo y seguimiento",
    "Historial de pedidos",
    "Encargo, prueba y presupuesto",
    "Conversación",
    "Devolución o cancelación",
    "Ayuda y reclamación",
    "Reseña de compra",
    "Crédito regalo",
    "Acceso y recuperación",
    "Cuenta y seguridad",
    "Consentimiento y privacidad",
    "Conexiones de agentes",
    "Registro de vendedor",
    "Panel de acciones",
    "Anuncios e importación",
    "Editor de artículos",
    "Tienda y políticas",
    "Producción y pruebas",
    "Envío y seguimiento",
    "Saldo y pagos",
    "Revisión de reembolso",
    "Promociones y estadísticas",
    "Mensajes del vendedor",
    "Infracciones y recursos",
    "Soporte",
    "Moderación y propiedad intelectual",
    "Conciliación y disputas",
    "Países y políticas",
    "Incidentes y auditoría",
    "Cola de privacidad",
    "API y guía de agentes",
  ],
  fr: [
    "Découvrir",
    "Résultats de recherche",
    "Article et provenance",
    "Boutique",
    "Favoris et collections",
    "Liste et réservation de cadeaux",
    "Panier multiboutique",
    "Paiement et confirmation",
    "Reçu et suivi",
    "Historique des commandes",
    "Commande sur mesure, épreuve et devis",
    "Conversation",
    "Retour ou annulation",
    "Aide et réclamation",
    "Avis d’achat",
    "Crédit cadeau",
    "Connexion et récupération",
    "Compte et sécurité",
    "Consentement et confidentialité",
    "Connexions d’agents",
    "Inscription vendeur",
    "Tableau des actions",
    "Annonces et importation",
    "Éditeur d’article",
    "Boutique et politiques",
    "Production et épreuves",
    "Expédition et suivi",
    "Solde et versements",
    "Examen du remboursement",
    "Promotions et statistiques",
    "Messages vendeur",
    "Infractions et recours",
    "Assistance",
    "Modération et propriété intellectuelle",
    "Rapprochement et litiges",
    "Pays et politiques",
    "Incidents et audit",
    "File de confidentialité",
    "API et guide des agents",
  ],
  de: [
    "Entdecken",
    "Suchergebnisse",
    "Artikel und Herkunft",
    "Shop",
    "Favoriten und Sammlungen",
    "Geschenkliste und Reservierung",
    "Shopübergreifender Warenkorb",
    "Zahlung und Bestätigung",
    "Beleg und Verlauf",
    "Bestellverlauf",
    "Sonderauftrag, Entwurf und Angebot",
    "Unterhaltung",
    "Rückgabe oder Stornierung",
    "Hilfe und Beschwerde",
    "Kaufbewertung",
    "Geschenkguthaben",
    "Anmeldung und Wiederherstellung",
    "Konto und Sicherheit",
    "Einwilligung und Datenschutz",
    "Agentenverbindungen",
    "Verkäuferregistrierung",
    "Aufgabenübersicht",
    "Angebote und Import",
    "Artikeleditor",
    "Shop und Richtlinien",
    "Produktion und Entwürfe",
    "Versand und Sendungsverfolgung",
    "Guthaben und Auszahlungen",
    "Erstattungsprüfung",
    "Aktionen und Statistiken",
    "Verkäufernachrichten",
    "Verstöße und Einsprüche",
    "Kundendienst",
    "Moderation und Urheberrecht",
    "Abgleich und Streitfälle",
    "Länder und Richtlinien",
    "Vorfälle und Prüfung",
    "Datenschutzaufgaben",
    "API und Agentenanleitung",
  ],
  ja: [
    "見つける",
    "検索結果",
    "作品と来歴",
    "ショップ",
    "お気に入りとコレクション",
    "ギフトリストと予約",
    "複数ショップのカート",
    "お支払いと確認",
    "領収書と注文状況",
    "注文履歴",
    "オーダーメイド・校正・見積もり",
    "メッセージ",
    "返品・キャンセル",
    "注文の相談と異議申し立て",
    "購入レビュー",
    "ギフトクレジット",
    "ログインと復旧",
    "アカウントとセキュリティ",
    "同意とプライバシー",
    "エージェント連携",
    "出店登録",
    "出店者のタスク",
    "出品とインポート",
    "作品の編集",
    "ショップとポリシー",
    "制作と校正",
    "発送と追跡",
    "残高と入金",
    "返金の確認",
    "プロモーションと分析",
    "出店者メッセージ",
    "違反通知と異議申し立て",
    "サポート",
    "モデレーションと知的財産",
    "照合と紛争",
    "国・手数料・ポリシー",
    "インシデントと監査",
    "プライバシー対応",
    "APIとエージェントガイド",
  ],
};
const extras = {
  en: {
    intro: "Creative work, with a story you can follow.",
    sub: "Explore independent work. Understand its origin, care and terms before you buy.",
    private: "Private preview · Real payments and outside services are switched off",
    empty: "Nothing to show here yet.",
    denied: "You don’t have access to this. Sign in, or ask for access.",
    stale:
      "This page has changed. Refresh and check the latest version before continuing.",
    error: "We couldn’t load this. What you’ve entered is still here, except sensitive details.",
    pending:
      "Still processing. Check the status before trying again.",
    success: "Confirmed. You’re all set.",
    ready: "Up to date",
    original: "Original",
    translated: "Translation",
    sponsored: "Sponsored",
    demo: "DEMO · Not for sale",
    review:
      "Check exactly what will change. Nothing happens until you confirm.",
    expiry: "This review has expired. Refresh to start again.",
    signin: "Sign in to your preview account",
    password: "Password",
    signout: "Sign out",
    username: "Username",
    session: "Signed in as",
    filter: "Filter",
    kind: "Creative type",
    all: "All",
    sort: "Sort",
    relevance: "Relevance",
    newest: "Newest",
    price: "Price",
    details: "Details",
    download: "Private download",
    reason: "Reason",
    status: "Status",
    version: "Version",
    updated: "Updated",
    next: "Next",
    notfound: "Page not found",
    home: "Home",
    unavailable: "There’s nothing you can do here right now.",
    reference: "Reference",
    reviewMissing: "Please review and confirm this before it can go ahead.",
    localNotice:
      "Test accounts only. This preview doesn’t verify real identities or take real payments.",
    items: "Results",
    destination: "Destination country",
    query: "Search creative work",
    retryUnsafe:
      "Refresh to check the status first. Don’t repeat a payment or refund until you know whether the first one went through.",
    choose: "Choose",
    required: "Required",
    draft: "Draft kept",
    unknown: "Unknown",
    notReady: "We can’t connect right now",
    agent: "Prepared by an AI agent. A person needs to confirm it.",
    send: "Continue",
    back: "Back",
    expires: "Expires",
    grant: "We check your permission every time you take an action.",
  },
  es: {
    intro: "Creaciones con una historia que puedes conocer.",
    sub: "Descubre obras independientes. Conoce su origen, cuidado y condiciones antes de comprar.",
    private:
      "Vista previa privada · Los pagos reales y los servicios externos están desactivados",
    empty: "Todavía no hay datos.",
    denied: "No tienes acceso a esto. Inicia sesión o solicita acceso.",
    stale: "Esta página ha cambiado. Actualiza y revisa la versión más reciente antes de continuar.",
    error: "No pudimos cargar esto. Lo que has escrito sigue aquí, salvo los datos sensibles.",
    pending: "Todavía se está procesando. Consulta el estado antes de volver a intentarlo.",
    success: "Confirmado. Todo listo.",
    ready: "Actualizado",
    original: "Original",
    translated: "Traducción",
    sponsored: "Patrocinado",
    demo: "DEMO · No está en venta",
    review:
      "Comprueba exactamente qué va a cambiar. No ocurre nada hasta que confirmes.",
    expiry: "Esta revisión ha caducado. Actualiza para empezar de nuevo.",
    signin: "Inicia sesión en tu cuenta de prueba",
    password: "Contraseña",
    signout: "Cerrar sesión",
    username: "Nombre de usuario",
    session: "Sesión iniciada como",
    filter: "Filtrar",
    kind: "Tipo de creación",
    all: "Todos",
    sort: "Ordenar",
    relevance: "Relevancia",
    newest: "Más recientes",
    price: "Precio",
    details: "Detalles",
    download: "Descarga privada",
    reason: "Motivo",
    status: "Estado",
    version: "Versión",
    updated: "Actualizado",
    next: "Siguiente",
    notfound: "Página no encontrada",
    home: "Inicio",
    unavailable: "Ahora mismo no hay nada que puedas hacer aquí.",
    reference: "Referencia",
    reviewMissing:
      "Revisa y confirma esto antes de que pueda seguir adelante.",
    localNotice:
      "Solo cuentas de prueba. Esta vista previa no verifica identidades reales ni cobra pagos reales.",
    items: "Resultados",
    destination: "País de destino",
    query: "Buscar creaciones",
    retryUnsafe:
      "Actualiza primero para consultar el estado. No repitas un pago o reembolso hasta saber si el primero se ha realizado.",
    choose: "Elegir",
    required: "Obligatorio",
    draft: "Borrador conservado",
    unknown: "Desconocido",
    notReady: "No podemos conectarnos ahora mismo",
    agent: "Preparado por un agente de IA. Una persona debe confirmarlo.",
    send: "Continuar",
    back: "Volver",
    expires: "Caduca",
    grant: "Comprobamos tus permisos cada vez que realizas una acción.",
  },
  fr: {
    intro: "Des créations dont vous pouvez suivre l’histoire.",
    sub: "Découvrez des œuvres indépendantes. Comprenez leur origine, leur entretien et leurs conditions avant d’acheter.",
    private: "Aperçu privé · Les paiements réels et les services externes sont désactivés",
    empty: "Aucun élément pour le moment.",
    denied: "Vous n’avez pas accès à ce contenu. Connectez-vous ou demandez l’accès.",
    stale: "Cette page a changé. Actualisez et vérifiez la dernière version avant de continuer.",
    error: "Impossible de charger ce contenu. Vos saisies sont conservées, sauf les informations sensibles.",
    pending: "Traitement en cours. Vérifiez le statut avant de réessayer.",
    success: "Confirmé. Tout est prêt.",
    ready: "À jour",
    original: "Original",
    translated: "Traduction",
    sponsored: "Sponsorisé",
    demo: "DÉMO · Pas à vendre",
    review:
      "Vérifiez exactement ce qui va changer. Rien ne se passe tant que vous n’avez pas confirmé.",
    expiry: "Cette vérification a expiré. Actualisez pour recommencer.",
    signin: "Se connecter au compte d’aperçu",
    password: "Mot de passe",
    signout: "Déconnexion",
    username: "Nom d’utilisateur",
    session: "Connecté en tant que",
    filter: "Filtrer",
    kind: "Type de création",
    all: "Tous",
    sort: "Trier",
    relevance: "Pertinence",
    newest: "Plus récents",
    price: "Prix",
    details: "Détails",
    download: "Téléchargement privé",
    reason: "Motif",
    status: "État",
    version: "Version",
    updated: "Mis à jour",
    next: "Suivant",
    notfound: "Page introuvable",
    home: "Accueil",
    unavailable: "Vous ne pouvez rien faire ici pour le moment.",
    reference: "Référence",
    reviewMissing:
      "Veuillez vérifier et confirmer ceci avant de poursuivre.",
    localNotice:
      "Comptes de test uniquement. Cet aperçu ne vérifie aucune identité réelle et n’encaisse aucun paiement réel.",
    items: "Résultats",
    destination: "Pays de destination",
    query: "Rechercher des créations",
    retryUnsafe:
      "Actualisez d’abord pour vérifier le statut. Ne répétez pas un paiement ou un remboursement avant de savoir si le premier a abouti.",
    choose: "Choisir",
    required: "Obligatoire",
    draft: "Brouillon conservé",
    unknown: "Inconnu",
    notReady: "Connexion impossible pour le moment",
    agent: "Préparé par un agent IA. Une personne doit le confirmer.",
    send: "Continuer",
    back: "Retour",
    expires: "Expire",
    grant: "Nous vérifions vos autorisations à chaque action.",
  },
  de: {
    intro: "Kreative Werke mit nachvollziehbarer Geschichte.",
    sub: "Entdecken Sie unabhängige Werke. Prüfen Sie Herkunft, Pflege und Bedingungen vor dem Kauf.",
    private:
      "Private Vorschau · Echte Zahlungen und externe Dienste sind ausgeschaltet",
    empty: "Hier gibt es noch keine Einträge.",
    denied:
      "Sie haben keinen Zugriff darauf. Melden Sie sich an oder fragen Sie nach Zugriff.",
    stale:
      "Diese Seite hat sich geändert. Laden Sie neu und prüfen Sie die aktuelle Version, bevor Sie fortfahren.",
    error: "Das konnte nicht geladen werden. Ihre Eingaben bleiben erhalten, außer sensiblen Angaben.",
    pending:
      "Wird noch bearbeitet. Prüfen Sie den Status, bevor Sie es erneut versuchen.",
    success: "Bestätigt. Alles erledigt.",
    ready: "Aktuell",
    original: "Original",
    translated: "Übersetzung",
    sponsored: "Gesponsert",
    demo: "DEMO · Nicht zum Verkauf",
    review:
      "Prüfen Sie genau, was sich ändert. Es passiert nichts, bevor Sie bestätigen.",
    expiry: "Diese Prüfung ist abgelaufen. Laden Sie neu, um von vorn zu beginnen.",
    signin: "Beim Vorschaukonto anmelden",
    password: "Passwort",
    signout: "Abmelden",
    username: "Benutzername",
    session: "Angemeldet als",
    filter: "Filtern",
    kind: "Kreativart",
    all: "Alle",
    sort: "Sortieren",
    relevance: "Relevanz",
    newest: "Neueste",
    price: "Preis",
    details: "Details",
    download: "Privater Download",
    reason: "Grund",
    status: "Status",
    version: "Version",
    updated: "Aktualisiert",
    next: "Weiter",
    notfound: "Seite nicht gefunden",
    home: "Start",
    unavailable: "Hier können Sie gerade nichts tun.",
    reference: "Referenz",
    reviewMissing:
      "Bitte prüfen und bestätigen Sie dies, bevor es weitergehen kann.",
    localNotice:
      "Nur Testkonten. Diese Vorschau prüft keine echten Identitäten und nimmt keine echten Zahlungen an.",
    items: "Ergebnisse",
    destination: "Zielland",
    query: "Kreative Werke suchen",
    retryUnsafe:
      "Laden Sie zuerst neu, um den Status zu prüfen. Wiederholen Sie eine Zahlung oder Erstattung erst, wenn Sie wissen, ob die erste durchgegangen ist.",
    choose: "Auswählen",
    required: "Erforderlich",
    draft: "Entwurf bleibt erhalten",
    unknown: "Unbekannt",
    notReady: "Gerade keine Verbindung möglich",
    agent:
      "Von einem KI-Agenten vorbereitet. Ein Mensch muss es bestätigen.",
    send: "Fortfahren",
    back: "Zurück",
    expires: "Läuft ab",
    grant: "Wir prüfen Ihre Berechtigung bei jeder Aktion.",
  },
  ja: {
    intro: "物語までたどれる、創造的な作品。",
    sub: "独立した作り手の作品を探しましょう。購入前に、来歴、お手入れ、条件を確認できます。",
    private: "非公開プレビュー · 実際の決済と外部サービスはオフになっています",
    empty: "まだ表示できる情報はありません。",
    denied:
      "アクセス権がありません。ログインするか、アクセスを申請してください。",
    stale: "このページは変更されました。再読み込みし、最新の内容を確認してから続行してください。",
    error: "読み込めませんでした。機密性の高い情報を除き、入力内容はそのまま残っています。",
    pending: "処理中です。もう一度試す前に状況をご確認ください。",
    success: "確認されました。これで完了です。",
    ready: "最新の状態",
    original: "原文",
    translated: "翻訳",
    sponsored: "広告",
    demo: "デモ · 非売品",
    review:
      "何が変わるかを正確にご確認ください。確定するまで何も実行されません。",
    expiry: "この確認画面の有効期限が切れました。再読み込みしてやり直してください。",
    signin: "プレビュー用アカウントにログイン",
    password: "パスワード",
    signout: "ログアウト",
    username: "ユーザー名",
    session: "ログイン中のアカウント",
    filter: "絞り込み",
    kind: "作品の種類",
    all: "すべて",
    sort: "並べ替え",
    relevance: "関連度",
    newest: "新着順",
    price: "価格",
    details: "詳細",
    download: "非公開ダウンロード",
    reason: "理由",
    status: "状態",
    version: "バージョン",
    updated: "更新日時",
    next: "次へ",
    notfound: "ページが見つかりません",
    home: "ホーム",
    unavailable: "現在ここで行える操作はありません。",
    reference: "参照番号",
    reviewMissing: "進める前に内容を確認して確定してください。",
    localNotice:
      "テスト用アカウントのみ。このプレビューでは実際の本人確認や決済は行われません。",
    items: "件数",
    destination: "配送先の国",
    query: "作品を検索",
    retryUnsafe:
      "まず再読み込みして状況をご確認ください。最初の支払いや返金が完了したかわかるまで、繰り返さないでください。",
    choose: "選択",
    required: "必須",
    draft: "下書きを保持",
    unknown: "不明",
    notReady: "現在接続できません",
    agent: "AIエージェントが準備しました。人による確認が必要です。",
    send: "続ける",
    back: "戻る",
    expires: "有効期限",
    grant: "操作のたびに権限を確認しています。",
  },
};
const kinds = {
  en: {
    handmade: "Handmade",
    designed: "Designed",
    vintage: "Vintage",
    supply: "Supplies",
    digital: "Digital",
    custom: "Custom",
  },
  es: {
    handmade: "Hecho a mano",
    designed: "Diseñado",
    vintage: "Vintage",
    supply: "Materiales",
    digital: "Digital",
    custom: "Personalizado",
  },
  fr: {
    handmade: "Fait main",
    designed: "Conçu",
    vintage: "Vintage",
    supply: "Fournitures",
    digital: "Numérique",
    custom: "Sur mesure",
  },
  de: {
    handmade: "Handgefertigt",
    designed: "Entworfen",
    vintage: "Vintage",
    supply: "Material",
    digital: "Digital",
    custom: "Sonderanfertigung",
  },
  ja: {
    handmade: "手作り",
    designed: "デザイン",
    vintage: "ヴィンテージ",
    supply: "材料",
    digital: "デジタル",
    custom: "オーダーメイド",
  },
};
export function copy(locale: LaunchLocale) {
  return {
    upload: {
      en: "Upload private file",
      es: "Subir archivo privado",
      fr: "Téléverser un fichier privé",
      de: "Private Datei hochladen",
      ja: "非公開ファイルをアップロード",
    }[locale],
    account: {
      en: "Account",
      es: "Cuenta",
      fr: "Compte",
      de: "Konto",
      ja: "アカウント",
    }[locale],
    ...extras[locale],
    kinds: kinds[locale],
    pack: getLocalePack(locale),
    title: (id: string) =>
      titles[locale][screens.findIndex((s) => s.screen_id === id)] ||
      extras[locale].notfound,
  };
}
export type Copy = ReturnType<typeof copy>;
